<nz-layout class="app-layout">

  <nz-layout>
    <app-header></app-header>
    <nz-content>
      <div class="inner-content">
        <router-outlet></router-outlet>
      </div>
    </nz-content>
  </nz-layout>
</nz-layout>
